export const lowerCasePasswordRegex = '^(?=.*[a-z])';
export const upperCasePasswordRegex = '^(?=.*[A-Z])';
export const symbolsPasswordRegex =
    '^(?=.*[!@#$%&\\-\\+\\?\\^\\{\\}\\(\\)\\[\\]\\|\\/])';
export const numericPasswordRegex = '^(?=.*[0-9])';
